<div class="Modal ModalAjudaPrevidencia">
  <div class="HeaderModal">
    <div class="IconModal float-start">
      <span class="material-icons"> help_outline </span>
      <p>Ajuda</p>
    </div>
    <span class="material-icons float-end CloseModal" (click)="closeModal()"> close </span>
  </div>
  <div class="ModalContent">
    <h1 class="TtlModal text-start">
      O que é Plano de Previdência e por que preciso contratá-lo?
    </h1>
    <p class="TxtModal text-start">
      O Plano de Previdência ou Pecúlio é uma modalidade de previdência
      complementar aberta que prevê cobertura por morte (qualquer causa), pago em
      parcela única aos beneficiários ou herdeiros legais do participante. Além da
      cobertura por morte (qualquer causa), clientes com plano ativo junto a
      Sabemi ainda podem usufruir do benefício da Assistência Financeira
      (Empréstimo Pessoal Consignado). Esta modalidade de empréstimo aplica-se
      exclusivamente a Seguradoras e Entidades Abertas de Previdência
      Complementar, suas regras são estabelecidas no Regulamento do Plano
      Individual de Pecúlio por Morte, sendo regulada pela SUSEP.
    </p>
  </div>
</div>
